export default "__VITE_ASSET__OTLOhuAS__"